if (!customElements.get('featured-blog')) {
  customElements.define(
    'featured-blog',
    class FeaturedBlog extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        if (!this.enableSlider && !this.enableSliderMobile) return;

        this.selectors = {
          itemsWrap: '.featured-blog__items-wrap',
          items: '.featured-blog__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.itemsWrap = this.querySelector(this.selectors.itemsWrap);
        this.items = this.querySelector(this.selectors.items);
        this.nextEl = this.querySelector(this.selectors.nextEl);
        this.prevEl = this.querySelector(this.selectors.prevEl);
        this.paginationEl = this.querySelector(this.selectors.pagination);

        this.itemsDesktop = parseFloat(this.dataset.items);
        this.itemsTablet = parseFloat(this.dataset.tabletItems);
        this.columnsMobile = parseFloat(this.dataset.columnsMobile);

        this.sliderInstance = false;

        if (!this.itemsWrap || !this.items) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          if (this.enableSliderMobile) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        } else {
          if (this.enableSlider) {
            this.initSlider();
          } else {
            this.destroySlider();
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const slidesPerViewMobile = Math.max(1, Math.min(2, this.columnsMobile + 0.5));

        const columnGap = window.getComputedStyle(this.items).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: slidesPerViewMobile,
          spaceBetween: Number.isFinite(spaceBetween) ? spaceBetween : 0,
          breakpoints: {
            768: {
              slidesPerView: this.itemsTablet,
            },
            1024: {
              slidesPerView: this.itemsDesktop,
            },
          },
          navigation: {
            nextEl: this.nextEl,
            prevEl: this.prevEl,
          },
          pagination: {
            el: this.paginationEl,
            type: 'bullets',
          },
          loop: false,
          threshold: 2,
        };

        this.itemsWrap.classList.add(this.classes.swiper);
        this.items.classList.remove(this.classes.grid);
        this.items.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this.itemsWrap, this.sliderOptions);
        this.sliderInstance.init();

        this.handleAccessibility();
      }

      handleAccessibility() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget !== null) {
              if (element.closest('.swiper-slide')) {
                const slide = element.closest('.swiper-slide');
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });
      }

      destroySlider() {
        this.itemsWrap.classList.remove(this.classes.swiper);
        this.items.classList.remove(this.classes.swiperWrapper);
        this.items.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}